import ApiService from '../api.service';
const moduleName = 'sign';
import axios from 'axios';

const SignService = {
    postStylusSign: async function(guid, sign, is_engineer) {
        try {
            let response = await ApiService.post(moduleName + '/postStylusSign?guid=' + guid, { sign, is_engineer });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    postSign: async function(guid, sign, is_engineer, is_qr) {
        try {
            let response = await ApiService.post(moduleName + '/postStylusSign?guid=' + guid, { sign, is_engineer, is_qr });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    requestToSign: async function(payload) {
        try {
            let response = await axios.post(`${process.env.VUE_APP_QR_URL}/sign`, payload, { withCredentials: false });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    checkSign: async function(guid) {
        try {
            let response = await axios.get(`${process.env.VUE_APP_QR_URL}/sign/${guid}`, { withCredentials: false });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    contractSign: async function(payload) {
        try {
            const response = await ApiService.post(moduleName + '/postContractPreTrialNoticeSign', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    accountSign: async function(payload) {
        try {
            const response = await ApiService.post(moduleName + '/postAccountPreTrialNoticeSign', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    bossSign: async payload => {
        try {
            const response = await ApiService.post(moduleName + '/postBossSign', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default SignService;
